import request from '@apps-common/js-client/api/request';

import {ORDERS_ENDPOINT} from '@explorer/config';
import {toolsObjectToGroupType} from '@explorer/components/dialogs/orders-dialog/group-items';
import {trackEvent} from '@explorer/analytics';

export const createOrderRequest = async orders => {
  const results = [];
  for (const order of orders) {
    const result = await request
      .post(ORDERS_ENDPOINT, {
        ...order,
        order_type: 'partial',
      })
      .then(res => {
        trackEvent('Order Placed Successfully', {
          orderName: order.name,
          itemType: order.products[0].item_type,
          productBundle: order.products[0].product_bundle,
          compositeType: toolsObjectToGroupType(order.tools),
        });

        return res.data;
      })
      .catch(err => {
        return {
          ...order,
          error: err,
        };
      });

    // This is needed in order to avoid 429s from API
    // Promise.all would have the same issue and would need a similar
    // buffer between requests
    await setTimeout(500);

    results.push(result);
  }

  return results;
};

export const getOrders = url =>
  request.get(url || ORDERS_ENDPOINT).then(response => response.data);
